import React, {useEffect, useRef, useState, forwardRef,useImperativeHandle } from 'react';
import styled  from 'styled-components';
// import Img1 from '../imgs/bg1@2x.png'
import Img1 from '../imgs/bg1.gif';
import { fetchCountDown } from '../api';
import PayResult from './PayResult';
import ReactDOM from 'react-dom'
let timer  = '';
const Clock = forwardRef(({showTime}, ref) => {
  const [isShowTime, setIsShowTime] = useState(false);
  const [isAddressShow, setIsAddressShow] = useState(false);
  const payResultRef = useRef()
  const [time, setTime] = useState({
    hh: '00',
    mm: '00',
    ss: '00',
  })


  useImperativeHandle(ref, () => {
    return {
      refresh: () => {
        if(!isShowTime) {
          console.log(showTime);
          init();
        }
  
      } 
      // ()=> {
        // fetchCountDown({})
        //   .then(res => {
        //     let countDown = ((res.lastComeInTime  + 24*60*60*1000 - new Date().getTime())/ 1000) ;
        //     if(res.isAddressShow) {
        //       setIsAddressShow(true);
        //     }
        //     if(res.isShow) {
        //       setIsShowTime(true);
        //     }

           
        //     clearInterval(timer);
          
        //     timer = setInterval(() => {
        //       if(time<=0) {
        //         setIsShowTime(false);
        //         clearInterval(timer);
        //       }
        //       countDown = countDown - 0.5;
        //       let hh = Math.floor(countDown/(60 * 60));
        //       let mm = Math.floor(countDown%(60*60)/60);
        //       let ss = Math.floor(countDown%(60 ));
        //       setTime({
        //         hh: hh.toString().padStart(2, "0"),
        //         mm: mm.toString().padStart(2, "0"),
        //         ss: ss.toString().padStart(2, "0"),
        //       })

        //     }, 1000);

        //   })
      // }
    }
  })

  useEffect(()=> {
    init();
    return () => clearInterval(timer);
  },[])

  function init() {
    fetchCountDown({})
    .then(res => {
      if(res.isAddressShow) {
        setIsAddressShow(true);
      }
      if(res.isShow) {
        console.log(showTime);
        showTime(true);
        setIsShowTime(true);
      }
      if(!res.lastComeInTime) {
        return
      }
      let countDown = ((res.lastComeInTime  + 24*60*60*1000 - new Date().getTime())/ 1000) ;
      clearInterval(timer);
      timer = setInterval(() => {
        if(time<=0) {
          setIsShowTime(false);
          showTime(false);
          clearInterval(timer);
        }
        countDown = countDown - 0.5;
        let hh = Math.floor(countDown/(60 * 60));
        let mm = Math.floor(countDown%(60*60)/60);
        let ss = Math.floor(countDown%(60 ));
        setTime({
          hh: hh.toString().padStart(2, "0"),
          mm: mm.toString().padStart(2, "0"),
          ss: ss.toString().padStart(2, "0"),
        })

      }, 1000);

    })
  }
  
  function initPage() {
    fetchCountDown({})
      .then(res => {
        if(res.isAddressShow) {
          setIsAddressShow(res.isAddressShow);
        } else {
          setIsAddressShow(false);
        }
      })

  }
  return (
    <ClockContainer>
      <div></div>
      {
        isAddressShow && <div className='addr'>请选择赠送了大鳄周边1套  <span onClick={()=> {

          payResultRef.current.show();
        }}>请选择>>></span> </div>
      }
      {
        isShowTime && <div className='time'>现下单+送30天！还剩 <span>{time.hh}</span>:<span>{time.mm}</span>:<span>{time.ss}</span>过期</div>
      } 
      
      <div className='bg1'>
        <div className='line'></div>
        <div > <img className='bg'  src={Img1}  alt=''/></div>
        {/* <img className='line1' src={require('../imgs/折线@2x.png')} alt=''/>
        <img className='line2' src={require('../imgs/光.gif')}  alt=''/> */}
        <img className='line3' src={require('../imgs/限时优惠@2x.png')}  alt=''/>
        <div className='left'>
          单价 
          <br />
          <span >¥1688</span>
        </div>
        
        <div className='right'>活动后恢复原价</div>
        <div className='bottom'><b>单价1000元/年</b></div>
      </div>

  
      {
         ReactDOM.createPortal(
          <PayResult ref={payResultRef}  onSubmit={()=> {
            // history.goBack();
            initPage()
          }}/>,
            document.body
         )
       }
    </ClockContainer>
  )
})

export default Clock;

const ClockContainer = styled.div`
  padding-top: 10px;
  .addr {
    height: 34px;
    background: rgba(0,0,0, 0.47);
    border-radius: 17px;
    text-align:center;
    margin: 10px 15px;
    line-height: 34px;
    font-size: 15px;
    color: #fff;
    box-sizing: border-box;


    span {
      color: #FFCD68;
    }
  }
  .time {
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom: -10px;
    line-height: 35px;
    text-align: center;
    span {
      display: inline-block;
      width: 26px;
      height: 26px;
      background: rgba(0, 0, 0,0.47);
      border-radius: 5px;
      line-height: 26px;
    }
  }
  .bg1 {
    width: 100vw;
    height:  55.5vw;
    margin: -10px auto 0;
    // background-image: url(${Img1}?${Math.random()});
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    position: relative;
    .bg {
      position: absolute;
      left: 0vw;
      width: 100%;
      height: 100%;
      z-index: 2;
      bottom: 0vw;
      

    }
    .line1 {
        position: absolute;
        left: 6.2vw;
        width: 80vw;
        z-index: 2;
        bottom: 14vw;
      
    }
    .line2 {
        position: absolute;
        left: 7.5vw;
        width: 40vw;
        z-index: 3;
        bottom: 16.5vw;
    }
      .line3 {
        position: absolute;
        left: 41vw;
        width: 18vw;
        z-index: 3;
        bottom: 20.5vw;
    }
    .right {
      position: absolute;
      right: 4vw;
      bottom: 42.5vw;

      font-family: Alibaba PuHuiTi !important;
      font-weight: 500;
      z-index: 5;
      font-size: 12px;
      color: #5F5F5F;
      line-height: 34px;
    }
    .left {
      position: absolute;
      left: 6vw;
      bottom: 30.5vw;

      font-family: Alibaba PuHuiTi !important;
      font-weight: 500;
      z-index: 5;
      font-size: 12px;
      color: #5F5F5F;
      > span {
        font-size: 18px;
        color: #F93056;
        font-weight: 500;
      }
    }
  }
  .bottom {
    position: absolute;
    // left: 50%;
    // transform: translatex(-50%);
    left: 0;
    bottom: 4vw;
    z-index: 5;
   
    font-family:system-ui !important;
    text-align: center;
    width: 100vw;
    font-weight: 900;
    font-size: 29px;
    color: #FF3E4A;
    line-height: 45px;
    font-style: italic;
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_135/components/Clock.js